<template>
  <div>
    <Blacklisted
      v-if="product.blacklisted"
      :product="product"
    />
    <DocStatus
      v-else-if="product.docNeeded"
      :product="product"
    />
    <div
      v-else
    >
      <LockReason
        v-if="product.lockReason === null || product.lockReason === false"
        :product="product"
      />
      <div v-else>
        <SaleStatusLabel :on-sale="product.onSale" />
        <div>
          {{ getProductLockReason }}
        </div>
        <div>
          İşlem yapmak için partner.trendyol.com'u kullanınız.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Index from './Index';

export default {
  name: 'IndexActionNeeded',
  extends: Index,
};
</script>
